export const DEFAULT_PLEDGE_EMAIL_BODY = `
    <p>Dear {donor_first_name}, </p>
    <p>Thank you for pledging {amount} to support {organization_name}. We appreciate your generosity and commitment.</p>
    <p>Please complete your donation, using the secure link below:</p>
    <p>{donation_link}</p>
    <p>We look forward to your continued support, and if you need any assistance, feel free to reach out.</p><p>Thank you,</p><p>{organization_name}</p>
`;
export const DEFAULT_PLEDGE_EMAIL_SUBJECT = `Your donation pledge to {organization_name}`;
//end default pledge email template

//default program email template
export const DEFAULT_PROGRAM_EMAIL_SUBJECT = `Your registration for {program_name} at {organization_name}`;
export const DEFAULT_PROGRAM_EMAIL_BODY = `
<p>Dear {participant_first_name},</p>
<p>Thank you for registering for {program_name} at {organization_name}. We’re excited to have you join us and appreciate your interest.</p>
<p>Your registration has been received successfully. We will share further details and updates about the program soon.</p>
<p>If you have any questions or need assistance, feel free to reach out.</p>
<p>Thank you,</p>
<p>{organization_name}</p>
`
//end default program email template


//special program email template start
export const DEFAULT__SPECIAL_PROGRAM_EMAIL_SUBJECT = `Your Iftar sponsorship has been received.`;
export const DEFAULT_SPECIAL_PROGRAM_EMAIL_BODY = `
<p>Assalamu alaikum {first_name},</p>
<p>JazakAllahu khayran for sponsoring Iftar for <b>Ramadan {ramadan_day}</b> at <b>{organization_name}</b>.</p>
<p>Because of your generosity, families and individuals will be able to break their fast together, insha’Allah. This act of giving carries immense reward, especially in the blessed month of Ramadan.</p>
<p><b>Sponsorship details.</b></p>
<ul>
<li>Iftar date: Ramadan {ramadan_day} ({gregorian_date})</li>
<li>Amount sponsored: {amount}</li>
</ul>
<p>May Allah accept this from you, place barakah in your wealth, and make it a means of forgiveness and multiplied reward.</p>
<p>If you’d like to sponsor additional days, you can do so at:</p>
<p>{campaign_link}</p>
<p>With gratitude,</p>
<p><b>{organization_name}</b></p>
`
//special program email template end

export const DEFAULT_EMAIL_BODY = `
    <p>Dear {donor_first_name},</p>
    <p><br></p>
    <p>This is a receipt for your generous donation to {organization_name}.</p>
    <p><br></p>
    <p>{donation_details}</p>
    <p><br></p>
    <p>Thank you,</p>
    <p><br></p>
    <p>{organization_name}</p>
`;

export const DEFAULT_EMAIL_SUBJECT = `Thanks for donating to {organization_name}`;

export const PAYMENT_METHOD_TYPE = {
    CARD: 'CARD',
    GOOGLE_PAY: 'GOOGLE_PAY',
    APPLE_PAY: 'APPLE_PAY',
    ACH: 'ACH'
}

export const PREFERRED_PAYMENT_METHOD_MAPPER = {
    "check":"Check",
    "cash":"Cash",
    "credit card":"Credit Card",
    "zelle":"Zelle",
    "paypal":"Paypal",
    "bank transfer":"Bank Transfer",
    "other": "Other"
}

export const DEVICE_LAYOUT_MAPPER = {
    "layout_1": 'Layout 1',
    "layout_2": 'Layout 2',
    "layout_3": 'Layout 3',
    "layout_4": 'Layout 4'
}

export const SORT_ITEM_TYPE = 'CARD';

export const PAYMENT_OPTION_MAPPER = {
    "one_time": 'One Time',
    "monthly": "Monthly",
    "free": "Free"
}

// color constant for donor tags
export const COLORS = [
  { name: "Green", bg: "#eaf3de", color: "#3b6d11", border: "#c0dd97" },
  { name: "Yellow", bg: "#faeeda", color: "#854f0b", border: "#fac775" },
  { name: "Red", bg: "#fce8e8", color: "#a32d2d", border: "#f09595" },
  { name: "Blue", bg: "#e6f1fb", color: "#185fa5", border: "#85b7eb" },
  { name: "Pink", bg: "#fbeaf0", color: "#993556", border: "#ed93b1" },
  { name: "Purple", bg: "#eeedfe", color: "#534ab7", border: "#afa9ec" },
  { name: "Gray", bg: "#f1efe8", color: "#5f5e5a", border: "#b4b2a9" },
];